export default __webpack_public_path__ + "6aa89b3bc052c595ebe400e00bf97ade.png";